import { EpostStatusTimelineContent } from '../../../Epost'
import { Container } from '../../Container'
import {
  EPOST_RECIPIENT,
  RAW_TIMLINE_WITH_TRACKING_ID,
  RAW_TIMLINE1,
} from '../EpostStatusTimeline.mocks'

import * as styles from './EpostStatusTimelineContents.module.css'

function EpostStatusTimelineContents() {
  return (
    <>
      <Container
        contentClassName={styles.content}
        label='Epost Status Timline Content, without tracking id'
      >
        <EpostStatusTimelineContent
          timeline={RAW_TIMLINE1}
          user={EPOST_RECIPIENT}
        />
      </Container>

      <Container
        contentClassName={styles.content}
        label='Epost Status Timline Content, with tracking id'
      >
        <EpostStatusTimelineContent
          timeline={RAW_TIMLINE_WITH_TRACKING_ID}
          user={EPOST_RECIPIENT}
        />
      </Container>
    </>
  )
}

export default EpostStatusTimelineContents
